import React from "react";
import "./Footer.css"; // Optional: If you want to style the footer

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>art by ajengtris (<a href="https://x.com/jengsix">check her here!</a>), website by vidya (and chatgpt and claude, really - I don't do web dev - oops)</p>
      </div>
    </footer>
  );
}

export default Footer;
